/* marquee  */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState="animation-play-state",css3AnimationIsSupported=false,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,false)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+":"+obj[p])}}tabjson.push();return"{"+tabjson.join(",")+"}"},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"paused")}else{if($.fn.pause){$marqueeWrapper.pause()}}$this.data("runningStatus","paused");$this.trigger("paused")},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"running")}else{if($.fn.resume){$marqueeWrapper.resume()}}$this.data("runningStatus","resumed");$this.trigger("resumed")},toggle:function(){methods[$this.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html())}};if(typeof options==="string"){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find(".js-marquee-wrapper")}if($this.data("css3AnimationIsSupported")===true){css3AnimationIsSupported=true}methods[options]()}return}var dataAttributes={},attr;$.each(o,function(key){attr=$this.attr("data-"+key);if(typeof attr!=="undefined"){switch(attr){case"true":attr=true;break;case"false":attr=false;break}o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1e3}verticalDir=o.direction==="up"||o.direction==="down";o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find(".js-marquee").css({"margin-right":o.gap,float:"left"});if(o.duplicated){$el.clone(true).appendTo($this)}$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find(".js-marquee-wrapper");if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({float:"none","margin-bottom":o.gap,"margin-right":0});if(o.duplicated){$this.find(".js-marquee:last").css({"margin-bottom":0})}var elHeight=$this.find(".js-marquee:first").height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration;o.duration=parseInt(elHeight,10)/parseInt(containerHeight,10)*o.duration}else{o.duration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration}}else{elWidth=$this.find(".js-marquee:first").width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration;o.duration=parseInt(elWidth,10)/parseInt(containerWidth,10)*o.duration}else{o.duration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration}}if(o.duplicated){o.duration=o.duration/2}if(o.allowCss3Support){var elm=document.body||document.createElement("div"),animationName="marqueeAnimation-"+Math.floor(Math.random()*1e7),domPrefixes="Webkit Moz O ms Khtml".split(" "),animationString="animation",animationCss3Str="",keyframeString="";if(elm.style.animation!==undefined){keyframeString="@keyframes "+animationName+" ";css3AnimationIsSupported=true}if(css3AnimationIsSupported===false){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+"AnimationName"]!==undefined){var prefix="-"+domPrefixes[i].toLowerCase()+"-";animationString=prefix+animationString;playState=prefix+playState;keyframeString="@"+prefix+"keyframes "+animationName+" ";css3AnimationIsSupported=true;break}}}if(css3AnimationIsSupported){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s infinite "+o.css3easing;$this.data("css3AnimationIsSupported",true)}}var _rePositionVertically=function(){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+elHeight+"px")+")")},_rePositionHorizontally=function(){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+elWidth+"px")+")")};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css("transform","translateY(0)")}else{$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+(elHeight*2-o.gap)+"px")+")")}}else{if(o.startVisible){$marqueeWrapper.css("transform","translateX(0)")}else{$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+(elWidth*2-o.gap)+"px")+")")}}if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction==="up"?o.duration+containerHeight/(elHeight/o.duration):o.duration*2}else{o.duration=o.direction==="left"?o.duration+containerWidth/(elWidth/o.duration):o.duration*2}if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}loopCount++}else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}loopCount++}}if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?0:"-"+elHeight+"px")+")")}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":containerHeight+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionVertically()}}else{_rePositionVertically();animationCss={transform:"translateY("+(o.direction==="up"?"-"+$marqueeWrapper.height()+"px":containerHeight+"px")+")"}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?0:"-"+elWidth+"px")+")")}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"}}}$this.trigger("beforeStarting");if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+" { 100%  "+_objToString(animationCss)+"}",$styles=$marqueeWrapper.find("style");if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$("head").append("<style>"+keyframeCss+"</style>")}_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger("finished")});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger("finished")})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger("finished");if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}$this.data("runningStatus","resumed")};$this.on("pause",methods.pause);$this.on("resume",methods.resume);if(o.pauseOnHover){$this.on("mouseenter",methods.pause);$this.on("mouseleave",methods.resume)}if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});

// Home page marquee
function allSiteMarquee() {
  var widthMarquee = $(window).width();
  if(widthMarquee < 750)
  {
    $('.Index_media_logo_slider_innerdesktop_slider_marquee').marquee({
      duration: 88000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_media_logo_slider_innerdesktop_slider_marquee').marquee({
      duration: 88000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }

  if(widthMarquee < 750)
  {
    $('.LP_Object_testimonial_slider_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.LP_Object_testimonial_slider_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
}
allSiteMarquee()

/* Header_mobile_nav_innerbottom_innerproducts_slider */
/*new Swiper('.Header_mobile_nav_innerbottom_innerproducts_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 12,
    slidesPerGroup: 1,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    observer: true,
    observeParents: true
})*/


// collection tab script
$(".Tabs_common_inner_new").click(function(){
   var tab_id = $(this).attr("tab_id");
   if($(this).hasClass("active") == false)
   {
     $(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_new").removeClass("active");
     $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display","none");
  
     $(this).addClass("active");
     $(this).parents(".Tabs_common_main_new").find("."+tab_id+"_open").css("display","block");
   }

   /*var width = $(window).width();
   if(width < 750){
     $(this).parent(".tab").css("display","none");
     $(this).parent().parent(".tab_title_main_new").removeClass("open");
  
     var selected_tab_name = $(this).html();
     $(this).parent().parent().find(".tab_title_mobile_inner_new").html(selected_tab_name);
   }*/
})
var lastScrollTop = 0;
var body = document.querySelector('body.template-collection');
if(body){
window.addEventListener("scroll",function(){
  var scrollTop = window.pageYOffset || document
  .documentElement.scrollTop;
  if(scrollTop > lastScrollTop){
      body.classList.remove("shownavbar");
  }
  else{
      body.classList.add("shownavbar");
  }
  lastScrollTop = scrollTop;
});
}


const pathName = window.location.pathname;
if(pathName.includes('/collections/')) {
  const collectionNavigation = document.querySelector('.collection-navigation');
  const collectionContainer = document.querySelector('.collection-container');
  if(collectionNavigation && collectionContainer) {
      window.addEventListener('scroll', function () {
        let marginTop = 77.5;
        if(window.innerWidth >= 991) {
          marginTop = 65.5;
        }
        const scrollY = window.scrollY + 77.5;
        const offsetTop = collectionContainer.offsetTop;
        if(scrollY >= offsetTop) {
          collectionNavigation.classList.add('sticky');
        } else {
          collectionNavigation.classList.remove('sticky');
        }
     });
  }
}


var Header_mobile_nav_innerbottom_innerproducts_slider = new Splide(".Header_mobile_nav_innerbottom_innerproducts_slider", {
  type: 'slide',
  perMove: 1,
  mobileFirst: true,
  arrows: false,
  rewind : false,
  autoWidth: true,
  padding: { left: '18px', right: '18px' },
  pagination: false,
  gap: '12px',
  speed: 1000,
  drag: true
})
Header_mobile_nav_innerbottom_innerproducts_slider.mount();



/* LP */
$('a[href^="#"]').on('click', function(event) {
  var target = $($(this).attr('href'));
  if (target.length) {
    event.preventDefault();
    $('html, body').stop().animate({
        scrollTop: target.offset().top
    }, 500);
  }
});

$(".play_icon_new").click(function(){
  if($(this).hasClass("active") == false)
  {
    $(this).parents(".video_play_list").find(".play_icon_new").removeClass("active");
    $(this).parents(".video_play_list").find('video').trigger('pause');
    $(this).parents(".video_play_list").find("svg.play_icon").css("display","block");
    /*$(this).parents(".video_play_list").find(".mute_video_main_new").removeClass("active");
    $(this).parents(".video_play_list").find(".mute_video").addClass("active");
    $(this).parents(".video_play_list").find(".unmute_video").removeClass("active");
    $(this).parents(".video_play_list").find("video").prop("muted",0)*/
    
    $(this).addClass("active");
    var URL = $(this).find('video').attr("video_url");
    if($(this).find('video').attr("src") == null)
    {
      $(this).find('video').attr("src",URL);
    }
    $(this).find('video').trigger('play');
    $(this).siblings().find('video').trigger('pause');
    $(this).siblings().find('svg.play_icon').css("display","block");
    $(this).find("svg.play_icon").css("display","none");
    /*$(this).parents(".video_main_block").find(".mute_video_main_new").addClass("active");*/
  }
  else
  {
    $(this).removeClass("active");
    $(this).find('video').trigger('pause');
    $(this).find("svg.play_icon").css("display","block");
    /*$(this).parents(".video_play_list").find(".mute_video_main_new").removeClass("active");*/
  }
})

$(".mute_video").click(function(){
  $(this).parents(".video_main_block").find(".mute_video").removeClass("active");
  $(this).parents(".video_main_block").find(".unmute_video").addClass("active");
  $(this).parents(".video_main_block").find("video").prop("muted",1)
})
$(".unmute_video").click(function(){
  $(this).parents(".video_main_block").find(".unmute_video").removeClass("active");
  $(this).parents(".video_main_block").find(".mute_video").addClass("active");
  $(this).parents(".video_main_block").find("video").prop("muted",0)
})

$(".LP_Object_tab_testimonial_block_innerboths_innerlists_new .common_tab_new .tablinks").click(function() {
  $(this).parents(".Tabs_common_main_new").find(".play_icon_new").removeClass("active");
  $(this).parents(".Tabs_common_main_new").find('video').trigger('pause');
  $(this).parents(".Tabs_common_main_new").find("svg.play_icon").css("display","block");
  /*$(this).parents(".Tabs_common_main_new").find(".mute_video").addClass("active");
  $(this).parents(".Tabs_common_main_new").find(".unmute_video").removeClass("active");
  $(this).parents(".Tabs_common_main_new").find("video").prop("muted",0)*/
})

function initAccordion() {
  $(".accordion .question").click(function() {
      if ($(this).parent("li").hasClass("open") == false) {
          //$(this).parents(".accordion").find(".answer").css("display", "none");
          $(this).parents(".accordion").find(".answer").slideUp();
          $(this).parents(".accordion").find("li").removeClass("open");

          //$(this).next(".answer").css("display", "block");
          $(this).next(".answer").slideDown();
          $(this).parent(".accordion li").addClass("open");
      } else {
          $(this).parents(".accordion").find(".answer").slideUp();
          //$(this).parents(".accordion").find(".answer").css("display", "none");
          $(this).parents(".accordion").find("li").removeClass("open");
      }
  })
}
initAccordion();

/* Size Guide Popup */
$(".full_ingredients_list_new").click(function () {
  $('body').addClass("overflow-hidden");
  $(".overlay_background").addClass("open");
  $(".product_full_ingredients_mainpopup_new").fadeIn();
})
$(".overlay_background, .product_full_ingredients_mainclose_new").click(function () {
  $('body').removeClass("overflow-hidden");
  $(".overlay_background").removeClass("open");
  $(".product_full_ingredients_mainpopup_new").fadeOut();
})

/* LP_Object_tab_right_testimonial_slider */
new Swiper('.LP_Object_tab_right_testimonial_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 32,
  slidesPerGroup: 1,
  slidesPerView: 4,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    768: {
      spaceBetween: 16
    },
    992: {
      spaceBetween: 16
    },
    1200: {
      spaceBetween: 32
    },
    1440: {
    }
  }
})

/* LP_Object_testimonial_slider */
new Swiper('.LP_Object_testimonial_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 56,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    768: {
      spaceBetween: 25
    },
    992: {
      spaceBetween: 35
    },
    1200: {
      spaceBetween: 45
    },
    1440: {
      spaceBetween: 56
    }
  }
})


/* LP_Image_with_text_column_slider */
new Swiper('.LP_Image_with_text_column_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 3,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: !1,
      loop: true,
    },
    768: {
      spaceBetween: 0,
      slidesPerView: 3,
      loop: false,
    },
    992: {
    },
    1200: {
    },
    1440: {
    }
  }
})


/* LP_Object_instagram_block_slider */
new Swiper('.LP_Object_instagram_block_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 32,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  }
})


/* LP_Object_tab_testimonial_slider */
new Swiper('.LP_Object_tab_testimonial_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  observer: true,
  observeParents: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  }
})

/* LP_Featured_collection_slider */
new Swiper('.LP_Featured_collection_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 30,
  slidesPerGroup: 1,
  slidesPerView: 4,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      slidesPerView: "auto",
      freeMode: !1
    },
    768: {
      spaceBetween: 20,
      slidesPerView: 3
    },
    992: {
      spaceBetween: 20,
      slidesPerView: 3
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 4
    },
    1440: {
    }
  }
})